import { createFileRoute } from '@tanstack/react-router'
import { EmployeePage } from '../../../../../features/hr/employee-page'
import { employeePageSearchSchema } from '../../../../../features/hr/search'

export const Route = createFileRoute('/_app/hr/employees/$employeeId/')({
  validateSearch: employeePageSearchSchema,
  component: EmployeePage,
})
